import React, { useState, useEffect } from 'react';

const HetznerUsercases = ({openModal}) => {
  const [activeTab, setActiveTab] = useState('private-cloud');
  const [isAnimating, setIsAnimating] = useState(false);

const tabs = [
  { id: 'private-cloud', label: 'Private Cloud Solutions' },
  { id: 'deployment', label: 'Application Deployment' },
  { id: 'kubernetes', label: 'Kubernetes Management' },
  { id: 'proxmox', label: 'Proxmox Virtualization' },
  { id: 'backup', label: 'Backup & Recovery' }
];

  const tabContent = {
  'private-cloud': {
    title: 'Private Cloud Solutions',
    content: `At AyanshTech Solutions, we design and deploy secure, high-performance Private Cloud Solutions environments on reliable Hetzner infrastructure. Our solutions include dedicated firewalls, advanced intrusion detection and prevention systems (IDS/IPS), and enterprise-grade security measures to protect your critical workloads. We build scalable and flexible Private Cloud Solutions platforms tailored to your organization's requirements and can provide complete management and ongoing support, allowing your team to focus on business growth.

A Private Cloud Solutions gives your business full control over applications, data, and infrastructure. Whether you use custom-developed software, business applications, or open-source technologies, we create an environment optimized for your operational needs, performance requirements, and security standards.`,
    features: [
      "Dedicated firewalls and advanced IDS/IPS protection",
      "Secure, scalable, and flexible cloud infrastructure",
      "Complete management and monitoring services",
      "Custom-built solutions tailored to your business needs"
    ]
  },

  'deployment': {
    title: 'Application Deployment',
    content: `At AyanshTech Solutions, we streamline application deployment through automated and reliable delivery processes. Our team builds robust CI/CD pipelines that enable fast, secure, and consistent deployments to your Hetzner infrastructure. From development and testing to production, we ensure smooth releases with minimal downtime and maximum efficiency.

We support modern deployment strategies such as blue-green deployments, rolling updates, and canary releases. Using industry-leading tools like Terraform, Ansible, GitHub Actions, and GitLab CI/CD, we automate your infrastructure and deployment workflows for greater speed, reliability, and scalability.`,
    features: [
      "Automated CI/CD pipelines",
      "Blue-green and canary deployments",
      "Infrastructure as Code (IaC)",
      "Fast and reliable application delivery"
    ]
  },

  'kubernetes': {
    title: 'Kubernetes Management',
    content: `At AyanshTech Solutions, we help businesses harness the full power of Kubernetes on Hetzner infrastructure. We design, deploy, and manage scalable container platforms that simplify application management while improving reliability and performance.

Our Kubernetes solutions include automated scaling, self-healing clusters, load balancing, service discovery, monitoring, and secure secrets management. Whether you need a development environment or a production-ready multi-node cluster, we implement best practices to ensure security, availability, and cost efficiency.`,
    features: [
      "Automated scaling and self-healing",
      "Load balancing and service discovery",
      "Secure secrets management",
      "Production-ready Kubernetes clusters"
    ]
  },

  'proxmox': {
    title: 'Proxmox Virtualization',
    content: `At AyanshTech Solutions, we specialize in building powerful virtualization environments using Proxmox VE on Hetzner dedicated servers. Our solutions provide flexible management of virtual machines and containers while ensuring high performance and reliability.

We configure complete Proxmox infrastructures with advanced storage solutions such as Ceph and ZFS, optimized networking, clustering, and backup systems. Our expertise helps businesses maximize hardware utilization while maintaining simplicity, scalability, and operational efficiency.`,
    features: [
      "Virtual machine and container management",
      "High availability cluster setup",
      "Ceph and ZFS storage solutions",
      "Scalable virtualization infrastructure"
    ]
  },

  'backup': {
    title: 'Backup & Recovery',
    content: `At AyanshTech Solutions, we provide comprehensive backup and disaster recovery solutions to keep your critical business data protected. Our backup strategies are designed to ensure data availability, minimize risks, and support rapid recovery in the event of unexpected failures.

We implement automated backups, off-site replication, snapshot management, and disaster recovery planning using trusted technologies such as Borg, Restic, and Veeam. Regular testing and monitoring ensure your backups remain reliable and recovery processes work when you need them most.`,
    features: [
      "Automated backup and recovery",
      "Off-site replication and redundancy",
      "Disaster recovery planning",
      "Backup monitoring and testing"
    ]
  }
};

  const handleTabChange = (tabId) => {
    if (tabId === activeTab) return;
    
    setIsAnimating(true);
    setTimeout(() => {
      setActiveTab(tabId);
      setTimeout(() => {
        setIsAnimating(false);
      }, 50);
    }, 200);
  };

  useEffect(() => {
    const container = document.querySelector('.tab-container');
    if (container) {
      container.classList.add('animated');
    }
  }, []);

  return (
    <section className='py-8 md:py-10 '>
        <div className='max-w-[1400px] mx-auto px-4'>
            <div class="text-center mb-16">
                <div class="transition-all duration-1000 opacity-100 translate-y-0">
                    <span class="text-blue-500 font-semibold text-xs uppercase tracking-wider">Success Stories & Use Cases</span>
                    <h2 class="text-2xl md:text-3xl font-bold text-gray-900 mt-2 mb-4">Powered by AyanshTech Solutions</h2><div class="w-16 h-1 bg-green-500 mx-auto"></div></div></div>
        
    <div className="w-full py-8 tab-container">
      {/* Tab Buttons */}
      <div className="flex flex-wrap justify-center gap-4 mb-8">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabChange(tab.id)}
            className={`px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
              activeTab === tab.id
                ? 'bg-gradient-to-br from-blue-500 to-green-600 text-white shadow-lg transform scale-105'
                : 'bg-gray-100 text-gray-600 hover:bg-green-200 hover:scale-105'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
        <div className={`p-8 md:p-12 transition-all duration-300 ${isAnimating ? 'opacity-0 transform scale-95' : 'opacity-100 transform scale-100'}`}>
          <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 flex items-center">
            <div className="w-3 h-3 bg-gradient-to-br from-blue-500 to-green-600 rounded-full mr-3"></div>
            {tabContent[activeTab]?.title}
          </h4>
          
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p className="text-base whitespace-pre-line">
              {tabContent[activeTab]?.content}
            </p>
            
            {/* Features List */}
            <div className="mt-6 pt-6 border-t border-gray-100">
              <h5 className="font-semibold text-gray-900 mb-3">Key Features:</h5>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {tabContent[activeTab]?.features.map((feature, index) => (
                  <div key={index} className="flex items-center space-x-2">
                    <svg className="w-4 h-4 text-blue-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-sm text-gray-600">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center transition-all duration-1000 delay-600 opacity-100 translate-y-0">
        <div class="bg-gradient-to-r from-gray-50 to-gray-100 rounded-2xl p-8 border border-gray-200">
            <h3 class="text-lg font-bold text-gray-900 mb-2">Beyond Standard Solutions</h3>
            <p class="text-gray-600 mb-6">Flexible infrastructure and services tailored to your specific needs.</p>
            <button onClick={openModal} class="inline-flex items-center px-8 py-4 bg-yellow-600 text-white font-semibold rounded-xl hover:bg-yellow-hover transform hover:scale-105 transition-all duration-300 shadow-lg" >Discuss Your Requirements
            <svg class="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
                </button>
                </div>
                </div>
    </div>
    
  </section>);
};

export default HetznerUsercases;